export default __webpack_public_path__ + "static/gradebg1-2c4a391b7a77bd281e911858107f394a.png";